module.exports = __webpack_public_path__ + "img/selection.cbebaa60.svg";